<div class="graphic-container" *ngIf="!isLoading; else loadingGraphic">
  <h3 class="graphic-title" *ngIf="headline">{{ headline }}</h3>
  <div
    class="graphic-content"
    [ngStyle]="{
      'background-color': backgroundColor,
      padding: isTransparent() ? '0' : '1rem',
    }"
  >
    <ng-container *ngFor="let src of getImageSources()">
      <hdi-image
        [src]="desktopImageSrc"
        [mobileSrc]="mobileImageSrc"
        [alt]="alt"
        [title]="title"
      />
    </ng-container>
  </div>
</div>

<!-- Loading Placeholder -->
<ng-template #loadingGraphic>
  <div class="graphic-container">
    <div class="graphic-content graphic-content--loader">
      <ngx-skeleton-loader
        [theme]="{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: '0',
          left: '0',
          'margin-bottom': '0',
          'background-color': '#f9f9fa',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</ng-template>
